module.exports = __webpack_public_path__ + "static/img/bg-page.798a869.png";